// services/invoice.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface InvoiceResult {
  invoiceId: string;
  status: string;
  hostedInvoiceUrl: string;
  invoicePdf: string;
}

export interface InvoiceListItem {
  id: string;
  status: string;
  amountDue: number;
  hostedInvoiceUrl: string;
  created: string;
}

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private apiUrl = environment.apiUrl + 'Invoices/';

  constructor(private http: HttpClient) {}

  sendInvoiceForBooking(bookingId: string): Observable<InvoiceResult> {
    return this.http.post<InvoiceResult>(`${this.apiUrl}booking/${bookingId}`, {});
  }

  getCustomerInvoices(userId: number): Observable<InvoiceListItem[]> {
    return this.http.get<InvoiceListItem[]>(`${this.apiUrl}customer/${userId}`);
  }
}
